(function () {
  'use strict';

  angular.module('wsLrs.services').factory('CardDisplay', ['$compile', '$q', '$timeout', 'Alerts', 'AppPermissions', 'Card', 'CardGroup', 'CardRegistry', 'CardLoader', 'CardUtils', 'ChartUtils', 'CardTemplates', 'DefaultCardGroups', 'Logger', 'screenSize', 'User', 'UserRoles', 'wsConstants', '$rootScope', 'wsEventNames', 'Utils', 'UserPreferences', 'ViewDashboardsAs', function ($compile, $q, $timeout, Alerts, AppPermissions, Card, CardGroup, CardRegistry, CardLoader, CardUtils, ChartUtils, CardTemplates, DefaultCardGroups, Logger, screenSize, User, UserRoles, wsConstants, $rootScope, wsEventNames, Utils, UserPreferences, ViewDashboardsAs) {
    function showCard(templateName) {
      //xs = phone and sm = tablet
      return !(templateName === "bookmarklet-activity" && screenSize.is("xs, sm"));
    }
    function isMobileView() {
      return screenSize.is("xs, sm");
    }
    return {
      cardGroup: null,
      _cardGrid: null,
      _groupingMode: false,
      $scope: null,
      reactGridLayout: [],
      saveOnLayout: false,
      ReactGrid: {
        updateLayoutState: function updateLayoutState() {} // This will be updated when the react component is created
      },
      removeChildElements: function removeChildElements(parentElement) {
        // remove existing child element from parentElement
        // first, $destroy() any scopes attached to the children
        var parentScope = angular.element(parentElement).scope();
        _.each(parentElement.children(), function (child) {
          var childScope = angular.element(child).scope();
          // if child element doesn't have an associated scope, angular returns
          // the parent scope. Make sure we don't destroy the parent scope!
          if (childScope && childScope !== parentScope) {
            childScope.$destroy();
            childScope = null;
          }
        });
        parentElement.children().remove();
      },
      createCardElement: function createCardElement(card, $scope, micro) {
        var htmlParts = "\n                        <div class=\"card-wrapper\" data-card-id=\"".concat(card.id, "\">\n                            ").concat(card.template.html, "\n                        </div>\n                    ");
        if (micro) {
          htmlParts = "\n                            <li class=\"card-group-item\">\n                                <div class=\"content\">\n                                    <h4>\n                                        <a ng-href=\"".concat(CardUtils.getCardUrl(card), "\">\n                                            ").concat(card.title, "\n                                        </a>\n                                    </h4>\n                                    <div class=\"report-summary\" ng-if=\"card.summary\">").concat(card.summary || "", "</div>\n                                </div>\n                            </li>\n                        ");
        }
        var bindScope = $compile(htmlParts),
          cardScope = $scope.$new();
        cardScope.card = card;
        cardScope.cardId = card.id;
        cardScope.detailsUrl = CardUtils.getCardUrl(card);
        cardScope.showDetailsLink = card.id !== "preview";
        cardScope.cardTemplate = card.template;

        /**
         * Append any additional report-specific data needed on cardScope.
         */
        var _ref = this.getSize(card.id) || {},
          width = _ref.width,
          height = _ref.height;
        var templateType = this.getTemplateType(card.id);
        if (width || height) {
          switch (templateType) {
            case 'leaderboard':
              var minMeasureWidth = 85; // px
              var dimensionWidth = width / 2.5; // px
              // For overriding the dimension width; used with an ngStyle directive
              cardScope.dimensionWidthStyle = {
                'max-width': "".concat(dimensionWidth, "px")
              };
              var hasTimeline = false;
              _.each(card.configuration.measures, function (m) {
                // If a timeline, account for a chunk of real estate
                if (m.aggregation && _.contains(["COUNT"], m.aggregation.type) && m.valueProducer.statementProperty === "timestamp") {
                  hasTimeline = true;
                }
              });
              var numMeasuresToDisplay = Math.floor((width - dimensionWidth) / minMeasureWidth);
              // Determine how many measures we should display
              cardScope.numMeasuresToDisplay = numMeasuresToDisplay > 0 ? numMeasuresToDisplay : 1;
              // this is the max number of measures we can display.  A timeline basically takes
              // up two measures so if we have a timeline, subtract one slot
              if (hasTimeline) {
                if (cardScope.numMeasuresToDisplay - card.configuration.measures.length >= 2) {
                  // If we have two additional "slots" left over, we can afford to
                  // show the timeline
                  cardScope.displayTimeline = true;
                }
              }
              cardScope.truncatingClass = {
                'max-width': dimensionWidth,
                'text-overflow': 'ellipsis',
                'white-space': 'nowrap',
                'overflow': 'hidden'
              };
              break;
            case 'heatmap':
              cardScope.hideValues = Utils._try(function () {
                var measures = card.configuration.measures.length;
                if (card.configuration.hiddenMeasures) {
                  measures = measures - card.configuration.hiddenMeasures.length;
                }
                var displayedMeasureCount = Math.min(measures, 10);
                return displayedMeasureCount * 60 > width;
              }, false);
              break;
            case 'column':
              cardScope.showCompactLabels = height < 500;
              cardScope.isResponsive = true;
              break;
            case 'bar':
              cardScope.showCompactLabels = width < 500;
              cardScope.isResponsive = true;
              break;
            default:
              break;
          }
        }
        $scope.$on('$destroy', function () {
          cardScope.$destroy();
        });
        return bindScope(cardScope);
      },
      /**
       * Despite the confusing name, this function just displays the individual cards within card-group cards.
       *
       * @param $scope
       * @param elementName
       * @param cardGroup
       */
      displayMicro: function displayMicro($scope, elementName, cardGroup) {
        var self = this;
        var parentElement = angular.element(elementName);
        var limit = self.getLimitParam($scope.card.id);

        // Append cards according to the current group's cardIds field
        _.each(cardGroup.cardIds.slice(0, limit), function (cardId) {
          var card = CardRegistry.get(cardId);
          var cardIsVisible = !card.hidden && card.template && showCard(card.template.name);
          if (cardIsVisible) {
            parentElement.append(self.createCardElement(card, $scope, true));
          }
        });
      },
      /**
       * Determine the size of the card based on its type. Returned height/width are in pixels.
       *
       * @param cardId {number}
       * @returns { Object<number, number> | null }
       */
      getSize: function getSizeParam(cardId) {
        // Preview will always be small and roughly this size; just an estimate is fine
        if ("".concat(cardId) === "preview") {
          return {
            height: 355,
            width: 387
          };
        }
        var reactGridItemLayout = _.find(this.reactGridLayout, {
          i: "".concat(cardId)
        });
        var headerHeight = this.getCardHeaderHeight(reactGridItemLayout);
        if (!headerHeight) {
          return null;
        }
        var cardElement = $("[data-card-id=\"".concat(cardId, "\"]"));
        if (!cardElement) {
          return null;
        }
        var height = cardElement.height() - headerHeight;
        var width = cardElement.width() - this.getCardWidthPadding(reactGridItemLayout);
        return {
          height: height,
          width: width
        }; // px
      },
      /**
       * Based on the report, determine how much data to load. The determination is returned
       * in the form of the "_limit" param passed to the server.
       *
       * Height or width are used for limits depending on the chart's orientation
       * (i.e. column vs. bar chart)
       *
       * @param cardId {Number}
       * @returns {Number}
       */
      getLimitParam: function getLimitParam(cardId) {
        var reactGridLayoutItem = _.find(this.reactGridLayout, {
          i: "".concat(cardId)
        });
        if (!reactGridLayoutItem) {
          return null;
        }
        var templateType = this.getTemplateType(cardId);
        var isHorizontalLimit = ['column', 'column-range'].indexOf(templateType) > -1;
        var cardSize = this.getSize(cardId) || {};
        var seriesProperties = this.getSeriesProperties(reactGridLayoutItem);
        if (isHorizontalLimit) {
          var width = cardSize.width;
          var seriesWidth = seriesProperties.seriesWidth;
          return width && seriesWidth ? Math.floor(width / seriesWidth) : 10;
        } else {
          var height = cardSize.height;
          var seriesHeight = seriesProperties.seriesHeight;
          return height && seriesHeight ? Math.floor(height / seriesHeight) : 10;
        }
      },
      /**
       * This function returns a card's template type based on the card's id
       * It performs some special logic around vertical bar charts to give better clarity when
       * working with size and limiting logic.
       *
       * @param cardId {Number}
       * @returns {string}
       */
      getTemplateType: function getTemplateType(cardId) {
        var card = CardRegistry.get(cardId);
        var templateType = card.template.name.toLowerCase();
        // Differentiate column from bar charts for the purpose of
        // loading extra data and determining how to measure series properties.
        if (templateType === 'bar') {
          return card.configuration.vertical ? 'column' : 'bar';
        }
        if (templateType === 'range') {
          return card.configuration.vertical ? 'column-range' : 'range';
        }
        return templateType;
      },
      displayCards: function displayCards($scope, cardGroup) {
        var self = this;

        // Set up scope variable for the displayed group
        $scope.cardGroup = cardGroup;
        self.cardGroup = cardGroup;
        self.$scope = $scope;
        self._cardGrid = $('.card-space');
        self.cardGroup.previousCardIds = self.cardGroup.cardIds.slice();
        var isResizable = true;
        AppPermissions.getForUser({
          value: 'explorer'
        }).then(function (permissions) {
          isResizable = (permissions.length || UserRoles.isExploreAllowed(User.get())) && !UserRoles.isConsultant(User.get()) && !ViewDashboardsAs.isActive;
        });
        return CardRegistry.multiGet(cardGroup.cardIds).then(function (unsortedCards) {
          var initialLayout = Utils._try(function () {
            return cardGroup.configuration.cardDisplaySettings;
          }, null);

          // Sort the cards into the order they will be displayed to assist with progressive loading
          var cards = cardGroup.cardIds.map(function (id) {
            return _.findWhere(unsortedCards, {
              "id": id
            });
          }).filter(function (card) {
            return card;
          }).sort(function (aCard, bCard) {
            if (!initialLayout) {
              return;
            }
            //look for the position of each of these cards
            var a = _.findWhere(initialLayout, {
              "i": aCard.id.toString()
            });
            var b = _.findWhere(initialLayout, {
              "i": bCard.id.toString()
            });

            //if we don't find one sort it to the bottom since it will be added there
            if (!a || !b) {
              return a ? -1 : 1;
            }

            //sort the cards based on their y position
            return a.y - b.y;
          });

          // If the initialLayout is still the old packery version (it doesn't include an 'i' element)
          // then we should just make it null so it will create the new react-grid layout.
          if (initialLayout && initialLayout[0] && Object.keys(initialLayout[0]).indexOf('i') === -1) {
            initialLayout = null;
          } else {
            self.reactGridLayout = initialLayout;
          }

          // Define our react-grid props for the component
          $scope.reactGridProps = {
            cardIds: cards.map(function (card) {
              return card.id;
            }),
            isMobileView: isMobileView(),
            initialLayout: initialLayout,
            isResizable: isResizable,
            initializeUpdateSavedLayoutFunction: function initializeUpdateSavedLayoutFunction(func) {
              return self.ReactGrid.updateLayoutState = func;
            },
            onLayoutChange: function onLayoutChange(cardLayout) {
              // Never save anything or modify data on mobile view
              if (isMobileView()) {
                return;
              }
              self.reactGridLayout = self.extendCardLayout(cardLayout);
              self.cardGroup.configuration = {
                cardDisplaySettings: self.reactGridLayout
              };
              self.cardGroup.previousCardIds = null;

              // Only save if there are any changes to the layout
              if (self.saveOnLayout) {
                CardGroup.save(self.cardGroup, {
                  params: {
                    addOnly: true
                  }
                });
              }
              self.saveOnLayout = true;
            },
            onResizeStop: function onResizeStop(layout, oldItem, newItem) {
              // This timeout gives the animation time to finish so the height/width of the
              // highchart doesn't get set incorrectly. Otherwise, it could be slightly larger
              // than the container because it modifies its size to the placeholder.
              $timeout(function () {
                var cardId = newItem.i;
                self.rerenderCardInGrid(cardId);
              }, 200);
            }
          };
          return self.appendChartsToGridItems(cards).then(function (didDisplayAnyCards) {
            $(".card-group-loading").addClass('ng-hide'); // Remove the loading spinner
            $rootScope.$broadcast(wsEventNames.cardDisplay.layoutComplete);
            return didDisplayAnyCards;
          });
        });
      },
      /**
       * Removes the card grid item associated with {cardId} and
       * appends a loading message. Afterwards, it re-creates the
       * compiled card html and re-appends it to the DOM. This
       * function is used to re-render leaderboards, and other charts
       * that rely on limiting to determine how many rows of data to
       * display.
       *
       * @param cardId
       */
      rerenderCardInGrid: function rerenderCardInGrid(cardId) {
        var self = this;
        var card = CardRegistry.get(parseInt(cardId));
        var gridItemToAppend = $("[data-card-id=\"".concat(cardId, "\"]"));

        // Remove the current chart
        gridItemToAppend.find('.card-wrapper').remove();
        // Remove any currently rendered tool tips
        ChartUtils.clearTooltips();

        // Add a loading message
        gridItemToAppend.append('<div class="loading-fresh">Loading Additional Data...</div>');
        self.appendChartsToGridItems([card]);
      },
      /**
       * This function compiles each report and appends it to the react grid item.
       * It returns true/false whether or not it displayed any cards.
       * @param cards - {Array}
       * @returns {Promise<boolean>}
       */
      appendChartsToGridItems: function appendChartsToGridItems(cards) {
        var self = this;

        // Append cards according to the current group's cardIds field
        var didDisplayAnyCards = false;

        // If we're in list view, no need to do anything else
        if (UserPreferences.getPreference('listView', {
          alt: false
        })) {
          return $q.resolve(true);
        }

        // $timeout is necessary so that angular has one digest cycle to
        // process the reactGridProps and append the DOM elements so that
        // gridItemToAppend should be defined.
        return $timeout(function () {
          // For each card, check if it should be shown
          _.each(cards, function (card) {
            // If a card should be shown, check if it already has
            // a chart appended to it. If not, append the card element.
            var cardIsVisible = card && !card.hidden && card.template && showCard(card.template.name);
            if (cardIsVisible) {
              var gridItemToAppend = $("[data-card-id=\"".concat(card.id, "\"]"));
              var elementNeedHTMLAppended = gridItemToAppend.find('.card-wrapper').length === 0;
              if (elementNeedHTMLAppended) {
                gridItemToAppend.append(self.createCardElement(card, self.$scope));
                var loadingLabel = gridItemToAppend.find('.loading-fresh');
                if (loadingLabel.length > 0) {
                  loadingLabel.remove();
                }
              }
              didDisplayAnyCards = true;
            }
          });
          return didDisplayAnyCards;
        }, 0);
      },
      /**
       * This is a display-only function. Does not persist anything.
       * @param cardId {number}
       */
      removeCard: function removeCard(cardId) {
        var self = this;
        // Do not do anything if not on a dashboard (i.e. from /reports page)
        if (!self.cardGroup || !self.reactGridLayout) {
          return;
        }
        // We disable saving on layout because the function that called this
        // function will handle persisting the card group.
        self.saveOnLayout = false;
        self.cardGroup.cardIds = self.cardGroup.cardIds.filter(function (id) {
          return id !== cardId;
        });
        self.reactGridLayout = self.reactGridLayout.filter(function (gridItem) {
          return gridItem.i !== "".concat(cardId);
        });
        self.ReactGrid.updateLayoutState(self.reactGridLayout);
      },
      loadCardPreview: function loadCardPreview($scope, card, parentElementName) {
        var self = this;
        CardLoader.getTemplateHtml(card.template).then(function (response) {
          //create temp copy of card to be used for preview
          var cardToPreview = angular.copy(card);
          cardToPreview.id = "preview";
          cardToPreview.template.html = response;
          CardRegistry.add(cardToPreview);

          //display card
          $scope.cardToPreview = cardToPreview;
          $timeout(function () {
            var parentElement = angular.element(parentElementName);
            //in case this is a refresh of an existing preview, remove the old card first
            self.removeChildElements(parentElement);
            parentElement.append(self.createCardElement(cardToPreview, $scope));
          });
        });
      },
      displayTopLevel: function displayTopLevel($scope, cardGroup) {
        var self = this;
        return CardRegistry.multiGet(cardGroup.cardIds).then(function cardLoadSuccess(cards) {
          // Shuffle cards to their correct default home, and display the group
          return DefaultCardGroups.addToDefaultGroups(cards).then(function () {
            return self.displayCards($scope, cardGroup);
          });
        }, function cardLoadFailure(response) {
          Logger.error("Card loading failed. Response code:" + response.status);
          $scope.loadFailureErrorMessage = "Card loading failed";
        });
      },
      enterGroupingMode: function enterGroupingMode(cardId) {
        var self = this,
          cards = $(self._cardGrid).find(".card-wrapper");
        function groupingMouseenter(evt) {
          var target = $(evt.currentTarget),
            targetId = target.scope().cardId;
          if (cardId !== targetId) {
            target.addClass("grouping");
          }
        }
        function groupingMouseleave(evt) {
          var target = $(evt.currentTarget),
            targetId = target.scope().cardId;
          if (cardId !== targetId) {
            target.removeClass("grouping");
          }
        }
        function groupingClick(evt) {
          evt.stopPropagation();
          evt.preventDefault();
          var target = $(evt.currentTarget),
            targetId = target.scope().cardId;
          if (cardId !== targetId) {
            self._groupCards(cardId, targetId);
            exitGroupingMode();
          }
        }
        function exitGroupingMode() {
          self._groupingMode = false;
          cards.off('mouseenter', '', groupingMouseenter);
          cards.off('mouseleave', '', groupingMouseleave);
          cards.off('click', '', groupingClick);
          $(document).off('click', '', exitGroupingMode);
          cards.removeClass("grouping");
          $(".grouping-message-wrapper").remove();
        }

        // Enter grouping mode
        self._groupingMode = true;
        cards.on('mouseenter', '', groupingMouseenter);
        cards.on('mouseleave', '', groupingMouseleave);
        setTimeout(function () {
          cards.on('click', '', groupingClick);
          $(document).on('click', '', exitGroupingMode);
        });
        $(document).keyup(function (evt) {
          if (evt.key === 'Escape') {
            exitGroupingMode();
          }
        });
        $("[data-card-id='" + cardId + "']").addClass("grouping");

        // A little wily / dangerous to just call out to some assumed
        // container name here.
        $("#main-container").append("<div class='grouping-message-wrapper'>" + "<div class='grouping-message'>" + "Click the report or report group you want to group this report with. <br><br> " + "Press escape, or click anywhere else, to cancel." + "</div>" + "</div>");
      },
      //----------------------------
      // Card Grouping
      //----------------------------
      _isGroupCard: function _isGroupCard(card) {
        return card.template.name === wsConstants.groupCardTemplateName;
      },
      _ensureGroupCard: function _ensureGroupCard(targetCard, sourceId) {
        var userId = this.cardGroup && this.cardGroup.user ? this.cardGroup.user.id : null;
        return Card.groupWith(sourceId, targetCard.id, userId);
      },
      _groupCards: function _groupCards(sourceId, targetId) {
        var self = this;

        // Hide contents of target card and resize it
        // This is the card whose place will be reserved for the new group card
        var targetCard = CardRegistry.get(targetId);

        // Filter out source card from grid
        self.reactGridLayout = self.reactGridLayout.filter(function (gridItem) {
          return gridItem.i !== "".concat(sourceId);
        });

        // Group cards and then:
        self._ensureGroupCard(targetCard, sourceId).then(function (groupCard) {
          groupCard.cardGroupIds.push(self.cardGroup.id);
          // Existing or new, ensure it's in the card registry
          CardRegistry.add(groupCard);

          // Ensure self.cardGroup.cardIds reflects the new group
          // and doesn't contain reference to the old cardIds
          self.cardGroup.cardIds = self.cardGroup.cardIds.filter(function (id) {
            return id !== sourceId && id !== targetId;
          });
          self.cardGroup.cardIds.push(groupCard.id);

          // Call the react component to update the grid. This is necessary
          // to place the card group in the same spot as the target card creating
          // the illusion of the in-place group card creation.
          var modifiedLayoutState = self.reactGridLayout.map(function (gridItem) {
            // Just replace the target card's id with the group card, thus
            // "taking" its place in the grid.
            if (gridItem.i === "".concat(targetId)) {
              gridItem.i = "".concat(groupCard.id);
              return gridItem;
            } else {
              return gridItem;
            }
          });

          // Update the react grid
          self.ReactGrid.updateLayoutState(modifiedLayoutState);
          self.rerenderCardInGrid(groupCard.id);
          var shouldEditGroupCardName = self._isGroupCard(groupCard) && groupCard.title === "Report Group";
          if (shouldEditGroupCardName) {
            $timeout(function () {
              $rootScope.$broadcast(wsEventNames.card.rename + groupCard.id);
            });
          }
          CardLoader.clearCache();
        });
      },
      //----------------------------
      // Utils
      //----------------------------
      /**
       * This function "extends" the passed-in card layout by adding data that is not returned
       * by the react grid "onLayoutChange" callback, but is needed to make measurements, etc.
       *
       * For example, headerHeight allows us to make accurate measurements when loading data on
       * initial page load. However, we calculate that field and it is not provided by the callback.
       * So we must extend the layout with this data before saving the card layout.
       *
       * @param cardLayout
       * @returns {Object}
       */
      extendCardLayout: function extendCardLayout(cardLayout) {
        var self = this;

        // For each card, try to get the headerHeight and elementHeight
        return cardLayout.map(function (el) {
          var reactGridLayoutItem = _.find(self.reactGridLayout, {
            i: "".concat(el.i)
          });
          if (!reactGridLayoutItem) {
            return el;
          }
          var extendedCardEl = angular.copy(el);
          var headerHeight = self.getCardHeaderHeight(reactGridLayoutItem);
          if (headerHeight) {
            extendedCardEl.headerHeight = headerHeight;
          }
          var _self$getSeriesProper = self.getSeriesProperties(reactGridLayoutItem),
            seriesHeight = _self$getSeriesProper.seriesHeight,
            seriesWidth = _self$getSeriesProper.seriesWidth;
          if (seriesHeight) {
            extendedCardEl.elementHeight = seriesHeight;
          }
          if (seriesWidth) {
            extendedCardEl.elementWidth = seriesWidth;
          }
          return extendedCardEl;
        });
      },
      /**
       * This function returns the height of a card's header in order to calculate the
       * _limit parameter for cards which load data according to their size.
       *
       * @param reactGridLayoutItem
       * @returns {Number}
       */
      getCardHeaderHeight: function getCardHeaderHeight(reactGridLayoutItem) {
        if (!reactGridLayoutItem) {
          return null;
        }
        var cardId = parseInt(reactGridLayoutItem.i);
        if (!cardId) {
          return null;
        }
        var templateType = this.getTemplateType(cardId);
        var measuredHeight = this.measureCardHeaderHeight(cardId, templateType);
        var storedHeight = reactGridLayoutItem.headerHeight;
        var defaultHeight = 36;
        return measuredHeight ? measuredHeight : storedHeight ? storedHeight : defaultHeight;
      },
      getCardWidthPadding: function getCardWidthPadding(reactGridLayoutItem) {
        if (!reactGridLayoutItem) {
          return null;
        }
        var cardId = parseInt(reactGridLayoutItem.i);
        if (!cardId) {
          return null;
        }
        var templateType = this.getTemplateType(cardId);
        var paddings = {
          'column': 65
        };
        return paddings[templateType] ? paddings[templateType] : 65;
      },
      /**
       * This function returns the height and width of a series which for the purposes of this
       * function is the html element that represents one series of data for a chart.
       * For instance, for a leaderboard one row is a set of data and this will return
       * the height of the rows in a leaderboard. For a bar chart, it would just be one bar.
       *
       * This is used to calculate the _limit param for charts which implement
       * loading more data based on their size.
       *
       * @param reactGridLayoutItem
       * @returns {Object|null}
       */
      getSeriesProperties: function getSeriesProperties(reactGridLayoutItem) {
        if (!reactGridLayoutItem) {
          return null;
        }
        var cardId = parseInt(reactGridLayoutItem.i);
        if (!cardId) {
          return null;
        }
        var templateType = this.getTemplateType(cardId);
        var defaultSeriesHeights = {
          'leaderboard': 31,
          'heatmap': 40,
          'interactions': 77,
          'card-group': 40,
          'bar': wsConstants.responsiveReports.pointWidth.bar
        };
        var defaultSeriesWidths = {
          'column': wsConstants.responsiveReports.pointWidth.column
        };

        // Height
        var _this$measureSeriesPr = this.measureSeriesProportions(cardId, templateType),
          measuredHeight = _this$measureSeriesPr.measuredHeight,
          measuredWidth = _this$measureSeriesPr.measuredWidth;
        var storedHeight = reactGridLayoutItem.elementHeight;
        var defaultHeight = defaultSeriesHeights[templateType];

        // Width
        var storedWidth = reactGridLayoutItem.elementWidth;
        var defaultWidth = defaultSeriesWidths[templateType];

        // We will attempt to return the fresh measurement,
        // the previously stored measurement, and finally,
        // a default height—-in that order. If all else fails,
        // return null.
        var seriesHeight = measuredHeight ? measuredHeight : storedHeight ? storedHeight : defaultHeight ? defaultHeight : null;
        var seriesWidth = measuredWidth ? measuredWidth : storedWidth ? storedWidth : defaultWidth ? defaultWidth : null;
        return {
          seriesHeight: seriesHeight,
          seriesWidth: seriesWidth
        };
      },
      /**
       * This function attempts to measure the height of the header for the given cardId.
       * If it cannot measure the header, it will return null.
       *
       * Each card has different things to be considered when measuring the header, so the
       * switch statement gives an easy way to extend this to new cards whose headers
       * may be different or need special considerations.
       *
       * @param cardId {Number}
       * @param templateType {String}
       * @returns {Number|null}
       */
      measureCardHeaderHeight: function measureCardHeaderHeight(cardId, templateType) {
        if (!cardId) {
          return null;
        }
        if (!templateType) {
          return null;
        }
        try {
          var card = $("[data-card-id=\"".concat(cardId, "\"]"));
          var headerHeight = card.find('[ws-card-header]').height(); // Same for all card types
          switch (templateType.toLowerCase()) {
            case 'heatmap':
              var BBox = card.find('.highcharts-xaxis-labels').get(0).getBBox();
              headerHeight += BBox.height + BBox.y;
              break;
            case 'leaderboard':
              var tableHeaderRow = card.find('thead>tr');
              headerHeight += tableHeaderRow.height();
              headerHeight += parseInt(tableHeaderRow.css('padding-top')) || 0;
              headerHeight += parseInt(tableHeaderRow.css('padding-bottom')) || 0;
              headerHeight += parseInt(tableHeaderRow.css('border-top')) || 0;
              headerHeight += parseInt(tableHeaderRow.css('border-bottom')) || 0;
              break;
            case 'card-group':
              // For simplicity's sake, we're adding the footer's height to the "header" height
              // This really just makes sure there's room for the footer without being pushed under
              // the group card.
              var footer = card.find('.card-footer .description');
              headerHeight += footer.height();
              headerHeight += parseInt(footer.css('padding-top')) || 0;
              headerHeight += parseInt(footer.css('padding-bottom')) || 0;
              break;
            case 'bar':
              headerHeight += 78;
              break;
            default:
              // Default cases don't need special measurements
              break;
          }

          // Account for padding around the main wrapper
          var mainWrap = card.find('.card-main-wrap');
          headerHeight += parseInt(mainWrap.css('padding-top')) || 0;
          headerHeight += parseInt(mainWrap.css('padding-bottom')) || 0;
          return headerHeight ? headerHeight : null;
        } catch (err) {
          return null;
        }
      },
      /**
       * This function attempts to measure the height and width for a series in the given cardId.
       * These proportions are vastly different for each card type, so we have a switch
       * statement which is where we define each card type's series that we're trying to measure.
       * In some cases this function will fire before cards have been rendered, which is an expected
       * case that results in simply returning null.
       *
       * If a measurement is successfully found, we return that.
       *
       * @param cardId
       * @param templateType
       * @returns {Object<Number|null, Number|null>}
       */
      measureSeriesProportions: function measureElementHeight(cardId, templateType) {
        if (!cardId) {
          return null;
        }
        if (!templateType) {
          return null;
        }
        var config = CardRegistry.get(cardId).configuration;
        var measuredHeight = null;
        var measuredWidth = null;
        var numberOfMeasures = Utils._try(function () {
          var hidden = config.hiddenMeasures ? config.hiddenMeasures.length : 0;
          return config.measures.length - hidden;
        }, 1);
        try {
          var card = $("[data-card-id=\"".concat(cardId, "\"]"));
          switch (templateType.toLowerCase()) {
            case 'leaderboard':
              var rows = card.find('tr[ng-repeat]');
              measuredHeight = rows.height();
              break;
            case 'heatmap':
              measuredHeight = card.find('.highcharts-series-0 > rect').get(0).getBBox().height;
              break;
            case 'interactions':
              // Account for height, padding, and border
              var elements = card.find('li[ng-repeat]');
              measuredHeight = elements.height();
              // Could be NaN, so leave 0 as alternative
              measuredHeight += parseInt(elements.css('padding-top')) || 0;
              measuredHeight += parseInt(elements.css('padding-bottom')) || 0;
              measuredHeight += parseInt(elements.css('border-top')) || 0;
              measuredHeight += parseInt(elements.css('border-bottom')) || 0;
              break;
            case 'card-group':
              var element = card.find('li.card-group-item');
              measuredHeight = element.height();
              measuredHeight += parseInt(element.css('padding-top')) || 0;
              measuredHeight += parseInt(element.css('padding-bottom')) || 0;
              measuredHeight += parseInt(element.css('border-top')) || 0;
              measuredHeight += parseInt(element.css('border-bottom')) || 0;
              break;

            // Bar chart width depends on the number of measures for each dimension + 10 padding
            case 'column':
              measuredWidth = numberOfMeasures <= 1 || config.stacking ? 20 : 10 * numberOfMeasures + 10;
              break;
            case 'bar':
              measuredHeight = numberOfMeasures <= 1 || config.stacking ? 20 : 10 * numberOfMeasures + 10;
              break;
            case 'column-range':
              measuredWidth = numberOfMeasures <= 2 ? 40 : 20 * numberOfMeasures + 10;
              break;
            case 'range':
              measuredHeight = numberOfMeasures <= 2 ? 40 : 20 * numberOfMeasures + 10;
              break;
            default:
              // If we haven't defined how to measure a card type's element,
              // then at best we'll just return null because in that case we're
              // not handling dynamic data loading.
              return {
                measuredHeight: null,
                measuredWidth: null
              };
          }
          return {
            measuredHeight: measuredHeight,
            measuredWidth: measuredWidth
          };
        } catch (err) {
          // Sometimes this function will be called before charts have rendered
          // in which case getBBox will be called on an undefined object.
          // In such a case, it's just easier to catch the error than to check
          // beforehand if the element exists.
          return {
            measuredHeight: null,
            measuredWidth: null
          };
        }
      }
    };
  }]);
})(this);
